import { useComplaintIntakeFormURLs } from "~/dcocom/hooks/useComplaintIntakeFormURLs";
import { Steps, useStepLookup } from "~/dcocom/hooks/useStepLookup";
import { dcocomWhistleblowIntakeFormURLs } from "~/dcocom/workflows/whistleblow/DcocomCreateWhistleblowState";
import { dcocomSupplychainIntakeFormURLs } from "~/dcocom/workflows/supplychain/DcocomCreateSupplychainState";
export function useComplaintSteps(): Steps {
  const urls = useComplaintIntakeFormURLs();
  return useStepLookup(urls);
}
export function useWhistleblowSteps(): Steps {
  return useStepLookup(dcocomWhistleblowIntakeFormURLs);
}
export function useSupplychainSteps(): Steps {
  return useStepLookup(dcocomSupplychainIntakeFormURLs);
}